// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20kR4","col":"styles_col__3HuQW"};